import { PaletteElement } from "./PaletteElement";
import { MyPoint } from "../../../typescript/MyPoint";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";

export class ColorPalette extends Phaser.GameObjects.Container {

    public currentColorID: number;

    public currentColor: Phaser.Display.Color;
    public scene: Phaser.Scene;

    public drawColorsElements: PaletteElement[];

    private paletteBackground: Phaser.GameObjects.Image;
    private paletteSelected: Phaser.GameObjects.Image;
    private backgroundColor: Phaser.Display.Color;

    private colorSizeInPalette: number;
    private colorsInRow: number;

    private drawColors: Phaser.Display.Color[];

    private paletteOrigin: MyPoint;

    constructor(ui_scene: Phaser.Scene, drawColors: Phaser.Display.Color[]) {

        super(ui_scene);

        this.scene = ui_scene;

        this.y = GameConstants.GAME_HEIGHT;
        this.scaleY = GameVars.scaleYMult * (1 / GameVars.correctionScale);

        this.drawColors = drawColors;
        this.backgroundColor = new Phaser.Display.Color(25, 25, 25, 1);
        this.colorsInRow = 6;
        this.colorSizeInPalette = (GameConstants.GAME_WIDTH / this.colorsInRow);

        // Create a transparent background for the palette (it will hold two lines of 4 colors each page)
        this.paletteBackground = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "PaletteTexture.png");
        this.paletteBackground.setOrigin(0, 1);
        this.paletteBackground.setScale(GameConstants.GAME_WIDTH / this.colorsInRow, this.colorSizeInPalette);

        // this.paletteBackground.setDisplaySize(PixelArt.GameConstants.GAME_WIDTH, (this.colorSizeInPalette * 2) * GameVars.scaleYMultInverse); 
        this.paletteBackground.setTintFill(this.backgroundColor.color);
        this.paletteBackground.setInteractive();
        this.paletteOrigin = new MyPoint(0, - this.colorSizeInPalette * 2);
        this.add(this.paletteBackground);

        this.createPaletteColors();

        // Create image for overlaying the selected color 
        this.paletteSelected = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "TileSelected.png");
        this.paletteSelected.setOrigin(0);
        this.paletteSelected.setDisplaySize(this.colorSizeInPalette, this.colorSizeInPalette);
        this.add(this.paletteSelected);

        // By default the first color will be the current 
        this.setSelectedID(1);
    }

    public update(deltaTime: number) {

        this.drawColorsElements.forEach(element => {
            element.update();
        });
    }

    public resetElements(): void {

        this.drawColorsElements.forEach(element => {
            element.setClosed(false);
        });
    }

    public getPaletteMinY(): number {

        return this.y - this.paletteBackground.scaleY * 2 * this.scaleY;
    }

    public getElement(id: number): PaletteElement {

        return this.drawColorsElements[id];
    }

    public setSelectedID(newID: number): void {

        // Update GameVars.CurrentColorID variable and set the image 
        // showing the color is selected 

        this.currentColorID = newID;
        GameVars.currentPixelColorID = this.currentColorID;
        newID--;

        let cellPage = Phaser.Math.FloorTo(newID / 12);
        let posRelativeToPage = newID - (12 * cellPage);

        let imagePos = new MyPoint(0, this.paletteOrigin.y);
        if (posRelativeToPage > 5) {
            imagePos.y += this.colorSizeInPalette;
            posRelativeToPage -= 6;
        }

        imagePos.x = posRelativeToPage * this.colorSizeInPalette;
        this.paletteSelected.setPosition(imagePos.x, imagePos.y);

        // Send an event to the Canvas Scene to show the target tiles darker 
        this.scene.registry.set("ColorPressed", true);
    }

    private offsetColorCells(distance: number): void {

        for (let i = 0; i < this.drawColorsElements.length; i++) {
            this.drawColorsElements[i].x += distance;
        }
    }

    private createPaletteColors(): void {

        this.drawColorsElements = [];

        for (let i = 0; i < this.drawColors.length; i++) {
            this.addColorToPalette(this.drawColors[i], i + 1);
        }
    }

    private addColorToPalette(newColor: Phaser.Display.Color, colorID: number): void {

        // Calculate image position
        let elmPage = Phaser.Math.FloorTo(this.drawColorsElements.length / 12);
        let posRelativeToPage = this.drawColorsElements.length - (12 * elmPage);

        let imagePos = new MyPoint(0, this.paletteOrigin.y);
        if (posRelativeToPage > 5) {
            imagePos.y += this.colorSizeInPalette; // Cell size
            posRelativeToPage -= 6;
        }

        imagePos.x = posRelativeToPage * this.colorSizeInPalette;
        let pageOffsetInPixels = (elmPage * this.colorSizeInPalette * 6);
        imagePos.x += pageOffsetInPixels;

        // Add it to the list
        const newElement = new PaletteElement(this.scene, this, imagePos, newColor, colorID, this.colorSizeInPalette);
        this.drawColorsElements.push(newElement);
        this.add(newElement);
    }
}

